import React from 'react'
import { withTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { useData } from "../../DataContext";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { 
    Button,
    Box,
    Typography
} from '@material-ui/core';

import TapImg from '../../images/tap.png'

import './RetrieveInfo.scss'

import { 
    Navbar,
    Header,
    StepHeader,
    FormBox,
    Footer
} from '../../components/_index'
import Scroll from 'react-scroll';

export default withTranslation()(function RetrieveInfo({t}) {
    let scroll = Scroll.animateScroll;
    const { setValues, data } = useData();
    const history = useHistory();

    const schema = yup.object().shape({
        applicantType: yup.string().required(t('common.normalErrorMsg1')),
    })

    const { 
        handleSubmit, 
        control, 
        errors 
    } = useForm({
        defaultValues: { 
            applicantType: 'Personal'
        },
        mode: "onBlur",
        resolver: yupResolver(schema),
    });

    const onSubmit = (data) => {
        console.log(data);
        setValues(data);
        history.push(`${process.env.REACT_APP_SUB_ROUTE}/personalInfo`);
    };

    const onError = (errors) => {
        scroll.scrollToTop();
    }

    return (
        <>
            <Box className="wrapper retrieveInfo">
                <Header langLock="langLocked" />
                <Box className="mainWrapper">
                    <Navbar step="step2" />
                    <Box className="contentWrapper">
                        <StepHeader 
                            step="common.step2" 
                            title="common.step2Title"
                            mandatory
                        />
                        <form onSubmit={handleSubmit(onSubmit, onError)} noValidate>
                            <FormBox header="step2.retrieveInfo.title">
                                <Box p={5}>
                                    <Typography variant="body1">
                                        {t('step2.retrieveInfo.msg1')}
                                    </Typography>
                                    <ol>
                                        <li>
                                            {t('step2.retrieveInfo.stepItm1')}
                                            <br />
                                            <img className="tapImg" src={TapImg} alt="" />
                                        </li>
                                        <li>{t('step2.retrieveInfo.stepItm2')}</li>
                                        <li>{t('step2.retrieveInfo.stepItm3')}</li>
                                    </ol>
                                </Box>
                            </FormBox>
                        </form>
                    </Box>
                </Box>
            </Box>
            <Footer />
        </>
    )
})
